import React, { useContext } from "react"
import { SubText, Text, Divider } from "../GameRulesStyles"
import { AppContext } from "../../../context/createContext"
import { Currencies } from "@orbital/games-frontend-library"

export default function AboutGameRules() {
  const {
    config: { rake },
    auth: {
      balance: { currency },
    },
    config,
  } = useContext(AppContext)

  return (
    <>
      <Text className={"big blue"} margin={"0 0 10px"}>
        About Game
      </Text>
      <Text className={"big white"} margin={"0 0 6px"}>
        Stellar guarantees entirely random outcomes. As a result, you may easily
        and quickly make money in this stunning game that stands out for its
        top-notch interplanetary and space aesthetics. To win big, all you have
        to do is place a bet before the space shuttle`s liftoff. In addition,
        you may place a single wager or two wagers on the same flight. So, to
        get the most out of the game, shoot for the stars as high as possible
        and avoid the shuttle’s explosion along the way.
      </Text>
      <Text className={"big blue"} margin={"0 0 6px"}>
        Win Calculation:{" "}
        <SubText className={"white"}>
          If you manage to avoid asteroids and jump sheep before explosion you
          will win your CURRENT BET AMOUNT x MULTIPLIER.
        </SubText>
        <br />
      </Text>
      <Text className={"big blue"} margin={"0 0 6px"}>
        Min Bet:{" "}
        <SubText className={"white"}>
          {config.minbet} {Currencies[currency]}
        </SubText>
      </Text>
      <Text className={"big green"} margin={"0 0 17px"}>
        Max Bet:{" "}
        <SubText className={"white"}>
          {config.maxbet} {Currencies[currency]}
        </SubText>
      </Text>
      <Text className={"big white"} margin={"0 0 17px"}>
        The overall theoretical return to player{" "}
        <SubText className={"big blue"}>(RTP)</SubText> is{" "}
        <SubText className={"big blue"}>{100 - rake}%</SubText>
      </Text>
      <Text className={"big white"} margin={"0 0 17px"}>
        The last
        <SubText className={"big blue"}> 20 bets</SubText> are shown in history
        as{" "}
        <SubText className={"big green"}>
          {" "}
          my bets, all bets and high rollers
        </SubText>
      </Text>
      <Text className={"big white"} margin={"0 0 17px"}>
        <SubText className={"blue"}>Min</SubText> multiplier in manual mode is{" "}
        <SubText className={"blue"}>1x</SubText>
      </Text>
      <Text className={"big white"} margin={"0 0 17px"}>
        <SubText className={"green"}>Max</SubText> multiplier in manual mode is{" "}
        <SubText className={"green"}>5000x</SubText>
      </Text>
      <Text className={"big white"} margin={"0 0 17px"}>
        <SubText className={"blue"}>Min</SubText> multiplier in autoplay is{" "}
        <SubText className={"blue"}>1.01x</SubText>
      </Text>
      <Text className={"big white"} margin={"0 0 17px"}>
        <SubText className={"green"}>Max</SubText> multiplier in autoplay is{" "}
        <SubText className={"green"}>5000x</SubText>
      </Text>
      <Text className={"big white"} margin={"0 0 17px"}>
        The
        <SubText className={"blue"}> maximum </SubText>possible amount at
        Cashout could be calculated by multiplying the bet amount by the{" "}
        <SubText className={"blue"}> maximum payout (5000x)</SubText>
      </Text>
      <Divider margin={"0 0 17px"} />
    </>
  )
}
